import { render, staticRenderFns } from "./PartnerDrivers.vue?vue&type=template&id=6cb56331&scoped=true&"
import script from "./PartnerDrivers.vue?vue&type=script&lang=js&"
export * from "./PartnerDrivers.vue?vue&type=script&lang=js&"
import style0 from "./PartnerDrivers.vue?vue&type=style&index=0&id=6cb56331&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb56331",
  null
  
)

export default component.exports